/* eslint-disable no-param-reassign */
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import TreeMenu from 'react-simple-tree-menu';
import {
  Wrapper, Chevron, ItemWrapper, TestDiv,
  TreeWrapper, StyledInput, List,
} from './styled';
import 'react-simple-tree-menu/dist/main.css';

// eslint-disable-next-line react/prop-types
const ToggleIcon = ({ on }) => (
  <Chevron className={on ? 'rotate' : ''}>
    <i className="fas fa-chevron-right" />
  </Chevron>
);

const ListItem = ({
  level = 0,
  hasNodes,
  isOpen,
  label,
  searchTerm,
  openNodes,
  toggleNode,
  matchSearch,
  focused,
  ...props
}) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <ItemWrapper focused={focused} level={level} {...props}>
    {hasNodes && (
      <TestDiv
        style={{ display: 'inline-block', width: 'auto' }}
        onClick={(e) => {
          // eslint-disable-next-line no-unused-expressions
          hasNodes && toggleNode && toggleNode();
          e.stopPropagation();
        }}
      >
        <ToggleIcon on={isOpen} />
      </TestDiv>
    )}
    {label}
  </ItemWrapper>
);

ListItem.propTypes = {
  level: PropTypes.number.isRequired,
  hasNodes: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  searchTerm: PropTypes.string.isRequired,
  openNodes: PropTypes.string.isRequired,
  toggleNode: PropTypes.func.isRequired,
  matchSearch: PropTypes.string.isRequired,
  focused: PropTypes.string.isRequired,
};

const SpecDropdownView = ({
  position,
  treeData,
  onChange,
  toggleDisplay,
}) => {
  const wrapperRef = useRef(null);

  const useOutsideBoundsPanel = () => {
    useEffect(() => {
      const handleClickOutsidePanel = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          toggleDisplay(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutsidePanel);
      return () => {
        document.removeEventListener('mousedown', handleClickOutsidePanel);
      };
    });
  };

  useOutsideBoundsPanel();

  const onClickTreeItem = ({ key }) => {
    if (key.includes('/')) {
      const leaf = key.split('/')[1];
      onChange(leaf);
      toggleDisplay(false);
    }
  };

  return (
    <Wrapper ref={wrapperRef} top={position.top} left={position.left}>
      <TreeWrapper>
        <TreeMenu onClickItem={onClickTreeItem} data={treeData}>
          {({ search, items }) => (
            <>
              <StyledInput
                onChange={(e) => search(e.target.value)}
                placeholder="Type and search"
              />
              <List>
                {items.map(({ reset, ...props }) => (
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  <ListItem {...props} />
                ))}
              </List>
            </>
          )}
        </TreeMenu>
      </TreeWrapper>
    </Wrapper>
  );
};

SpecDropdownView.propTypes = {
  treeData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func.isRequired,
  toggleDisplay: PropTypes.func.isRequired,
  position: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number,
  }).isRequired,
};

export default SpecDropdownView;
